import React from 'react'
import PropTypes from 'prop-types'
import { Spinner as NUISpinner } from '@theneatcompany/nui'
import cx from 'classnames'

import styles from './Spinner.module.scss'

const Spinner = ({ className = '', children }) => (
  <div className={cx(styles.container, className)}>
    <NUISpinner />
    {children}
  </div>
)

Spinner.propTypes = {
  className: PropTypes.string,
  children: PropTypes.func,
}

export default Spinner
